import { computed, ref } from 'vue'
import axios from 'axios'

const status = ref({
  enabled: false,
  available: false,
  provider: 'runware'
})
const loaded = ref(false)
const loading = ref(false)
let pendingRequest = null

export function useImageGenerationConfig() {
  const loadStatus = async (force = false) => {
    if (loaded.value && !force) return status.value
    if (pendingRequest) return pendingRequest

    loading.value = true
    pendingRequest = axios.get('/api/image-generation/status')
      .then((response) => {
        status.value = response.data
        loaded.value = true
        return status.value
      })
      .catch((error) => {
        status.value = { enabled: false, available: false, provider: 'runware' }
        loaded.value = true
        throw error
      })
      .finally(() => {
        loading.value = false
        pendingRequest = null
      })

    return pendingRequest
  }

  return {
    imageGenerationStatus: computed(() => status.value),
    imageGenerationAvailable: computed(() => status.value.available),
    imageGenerationStatusLoaded: computed(() => loaded.value),
    imageGenerationStatusLoading: computed(() => loading.value),
    loadImageGenerationStatus: loadStatus
  }
}
